import React, { useState } from "react";
import { Card, Typography, Space, Checkbox, Button, Badge, Carousel } from "antd";
import BackButton from "@/note_office/shared/BackButton";
import { useNavigate } from "react-router-dom";
import Checkmark from "@/note_office/icons/subscriptions/Checkmark";
import Xmark from "@/note_office/icons/subscriptions/Xmark";
import { useSubState } from "../State.js";

import translator from "@/translator";

const t = translator("note_office.views.subscriptions.index_view.subs_form.");

const { Text, Title } = Typography;

const Form = ({}) => {
  const { state, updateState } = useSubState();
  const navigate = useNavigate();
  const [currentPlanIndex, setCurrentPlanIndex] = useState(0);
  const [currentNamePlan, setCurrentNamePlan] = useState(state.sub_plans[0].name);

  const carouselChange = (index) => {
    const selected_plan = state.sub_plans[index];
    setCurrentPlanIndex(index);
    setCurrentNamePlan(selected_plan.name);
    if (selected_plan.name == "Free") {
      updateState({
        sum: 0,
        paid_period: 1,
        selected_plan: { ...selected_plan, lowest_price_special: 0, highest_price_special: 0 },
      });
    } else {
      updateState({ sum: 0, paid_period: 0 });
    }
  };

  const calcDiscount = (price) => {
    const discount =
      ((price.highest_price_special - price.lowest_price_special) / price.highest_price_special) *
      100;

    return Math.ceil(discount);
  };

  const onChangeCheckbox = (event, price) => {
    if (event.target.checked) {
      updateState({
        sum: price.lowest_price_special,
        paid_period: price.period,
        selected_plan: {
          ...state.sub_plans[currentPlanIndex],
          lowest_price_special: price.lowest_price_special,
          highest_price_special: price.highest_price_special,
        },
      });
    } else {
      updateState({ sum: 0, paid_period: 0 });
    }
  };

  const showSubmitButton = (currentNamePlan) =>
    state.customer_current_sub_plan.name != "Free" || currentNamePlan != "Free";

  const onSubmit = () => {
    return navigate("/new/approve");
  };

  const getSubmitButtonText = () => {
    if (currentNamePlan == "Free" && state.sum == 0) {
      return t("submit_button.free");
    }

    if (state.sum == 0) {
      return t("submit_button.one");
    }

    return t("submit_button.other", {
      sum: state.sum,
      localized_currency_unit: state.localized_currency_unit,
    });
  };

  const disableSubmitButton = () => {
    return currentNamePlan != "Free" && state.sum == 0;
  };

  return (
    <div className="wrapper wrapper__menu-layout overflow">
      <div className="subscription-form">
        <Space>
          <BackButton onClick={() => navigate("/")} title={t("title")} />
        </Space>
        <div className="subscription-form__carousel">
          <Carousel
            dots={{ className: `slick-dots ${currentNamePlan}` }}
            draggable={true}
            infinite={false}
            afterChange={carouselChange}
          >
            {state.sub_plans.map((plan) => (
              <Card key={plan.name} className={`subscription-form__tariff_plan_card`}>
                <div className="subscription-form__tariff_plan_card-title_box">
                  <Title
                    level={3}
                    className={`subscription-form__tariff_plan_card-title ${plan.name} `}
                  >
                    {plan.name}
                  </Title>
                  {state.customer_current_sub_plan.name == plan.name && (
                    <div className="subscription-form__tariff_plan_card-active_label">
                      {t("tarrif_card.active")}
                    </div>
                  )}
                </div>
                <div className="subscription-form__tariff_plan_card-list">
                  <Space direction="vertical" size={8}>
                    {plan.advantages.map((advantage, index) => (
                      <div key={index} className="subscription-form__tariff_plan_card-item">
                        <Space size={14}>
                          {advantage.checkmark ? (
                            <Checkmark
                              className={`subscription-form__tariff_plan_card-item_checkmark ${plan.name}`}
                            />
                          ) : (
                            <Xmark className="subscription-form__tariff_plan_card-item_xmark" />
                          )}
                          <Text>{advantage.title}</Text>
                        </Space>
                      </div>
                    ))}
                  </Space>
                </div>
              </Card>
            ))}
          </Carousel>
        </div>

        <div className="subscription-form__tariff_plan_price_card_container">
          {currentNamePlan != "Free" &&
            state.sub_plans[currentPlanIndex].prices.map((price) => (
              <Card className={`subscription-form__tariff_plan_price_card ${currentNamePlan}`}>
                <Checkbox
                  checked={state.sum == price.lowest_price_special}
                  onChange={(checked) => onChangeCheckbox(checked, price)}
                  className={`subscription-form__tariff_plan_price_card-checkbox ${currentNamePlan}`}
                />
                <div className="subscription-form__tariff_plan_price_card-box">
                  <div className="subscription-form__tariff_plan_price_card-box_title_box">
                    <Text className="subscription-form__tariff_plan_price_card-title">
                      {console.log(price)}
                      {console.log(t("price_card.period", { count: 3 }))}
                      {t("price_card.period", { count: price.period })}
                    </Text>
                    <div className="subscription-form__tariff_plan_price_card-title_price">
                      {`${price.lowest_price_special} ${state.localized_currency_unit}`}
                    </div>
                  </div>
                  <div className="subscription-form__tariff_plan_price_card-box_desc_box">
                    <Text
                      className={`subscription-form__tariff_plan_price_card-desc ${currentNamePlan}`}
                    >
                      {price.period == 1 && t("price_card.montly_charge")}
                      {price.period != 1 &&
                        t("price_card.discount", {
                          discount: calcDiscount(price),
                        })}
                    </Text>
                    {price.highest_price_special &&
                      price.highest_price_special != price.lowest_price_special && (
                        <div className="subscription-form__tariff_plan_price_card-desc_price">
                          {price.highest_price_special}
                        </div>
                      )}
                  </div>
                </div>
              </Card>
            ))}
        </div>

        {showSubmitButton(currentNamePlan) && (
          <Button
            disabled={disableSubmitButton()}
            type="primary"
            block
            className={`subscription-form__payment-button ${currentNamePlan}`}
            size="large"
            onClick={onSubmit}
          >
            {getSubmitButtonText()}
          </Button>
        )}
      </div>
    </div>
  );
};

export default Form;
